import { createWorkOrderSlice } from 'common/stores/redux/WorkOrder';

const contractorWorkOrderSlice = createWorkOrderSlice('contractorWorkOrder');

export const {
    init,
    replace,
    resetPages,
    update,
    replaceSnapshot,
    updateKeyValuePair,
    updateInstructions,
    updateContact,
    addNote,
    updateNote,
    addComment,
    updateComment,
    initFinancialInformation,
    updatePayment,
    updateBilling,
    addPhoto,
    removePhoto,
    addFolderAttachment,
    removeFolderAttachment,
} = contractorWorkOrderSlice.actions;

export default contractorWorkOrderSlice.reducer;
